export const setTheme = theme => {
    for (let [key, value] of Object.entries(theme)) {
        document.documentElement.style.setProperty(key, value);
    }
};
